let ctx;

// 检测移动端
const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

function initLenis() {
  // Initialize a new Lenis instance for smooth scrolling
  const lenis = new Lenis({
    prevent: (element) => {
      return element.classList.contains('disclosure__list') ||
        element.classList.contains('search') ||
        element.classList.contains('quick-add-modal__content') ||
        element.tagName === 'CART-DRAWER-ITEMS' ||
        element.classList.contains('rapoo-menu-tabs') ||
        element.classList.contains('menu-drawer__main') ||
        element.id === 'CartPopup'
    },
    // lerp: 0.1,
    smoothWheel: true
  });
  // Synchronize Lenis scrolling with GSAP's ScrollTrigger plugin
  lenis.on('scroll', ScrollTrigger.update);

  // Add Lenis's requestAnimationFrame (raf) method to GSAP's ticker
  // This ensures Lenis's smooth scroll animation updates on each GSAP tick
  gsap.ticker.add((time) => {
    lenis.raf(time * 1000); // Convert time from seconds to milliseconds
  });

  // Disable lag smoothing in GSAP to prevent any delay in scroll animations
  gsap.ticker.lagSmoothing(0);
}

function setupScreenAnimate() {
  const $list = $('.game-screen-img-list');
  const $items = $list.find('.game-screen-inner'); // 假设子元素类名为.game-screen-img-item
  const $titles = $('.game-screen-title'); // 假设子元素类名为.game-screen-img-item

  // 显示第一张图片
  let currentIndex = 0;



  setInterval(() => {
    let current = $items[currentIndex];
    let next;
    let currentTitle = $titles[currentIndex];
    let nextTitle;
    if (currentIndex >= $items.length - 1) {
      next = $items[0];
      nextTitle = $titles[0];
    } else {
      next = $items[currentIndex + 1];
      nextTitle = $titles[currentIndex + 1];
    }

    // 获取currentTitle下的title sub-title game-screen-btn
    const currentTitleTitle = currentTitle.querySelector('.title');
    const currentTitleSubTitle = currentTitle.querySelector('.sub-title');
    const currentTitleBtn = currentTitle.querySelector('.game-screen-btn');

    // 获取nextTitle下的title sub-title game-screen-btn
    const nextTitleTitle = nextTitle.querySelector('.title');
    const nextTitleSubTitle = nextTitle.querySelector('.sub-title');
    const nextTitleBtn = nextTitle.querySelector('.game-screen-btn');
    // 获取对应的data-delay attribute
    const nextTitleTitleDelay = nextTitleTitle.getAttribute('data-delay');
    const nextTitleSubTitleDelay = nextTitleSubTitle.getAttribute('data-delay');
    const nextTitleBtnDelay = nextTitleBtn.getAttribute('data-delay');
    console.log("start animate")
    const tl = gsap.timeline();
    tl.addLabel('start');
    tl.to(current,
      {
        opacity: 0,
        duration: 0.5,
      },
      'start'
    )
      .set(currentTitle,
        {
          opacity: 0,
          duration: 0.5,
          zIndex: 3
        }
      )
      .to(currentTitleTitle,
        {
          opacity: 0,
          duration: 0.5,
          zIndex: 3,
        },
        'start'
      )
      .to(currentTitleSubTitle,
        {
          opacity: 0,
          duration: 0.5,
          zIndex: 3,
        },
        'start'
      )
      .to(currentTitleBtn,
        {
          opacity: 0,
          duration: 0.5,
          zIndex: 3,
        },
        'start'
      )
      .fromTo(next,
        // 起始状态
        { opacity: 0, },
        // 结束状态
        {
          opacity: 1,
          duration: 0.5,
        },
        'start'
      )
      .addLabel('next-end')
      .set(nextTitle,
        {
          y: '0',
          opacity: 1,
          zIndex: 4,
        }
      )
      .fromTo(nextTitleTitle,
        // 起始状态
        { opacity: 0, y: '50%' },
        // 结束状态
        {
          y: '0',
          opacity: 1,
          duration: 1,
          zIndex: 4,
          delay: nextTitleTitleDelay,
          ease: "power2.out"
        },
        'start'
      )
      .fromTo(nextTitleSubTitle,
        // 起始状态
        { opacity: 0, y: '50%' },
        // 结束状态
        {
          y: '0',
          opacity: 1,
          duration: 1,
          zIndex: 4,
          delay: nextTitleSubTitleDelay,
          ease: "power2.out"
        },
        'start'
      )
      .fromTo(nextTitleBtn,
        // 起始状态
        { opacity: 0, y: '50%' },
        // 结束状态
        {
          y: '0',
          opacity: 1,
          duration: 1,
          zIndex: 4,
          delay: nextTitleBtnDelay,
          ease: "power2.out"

        },
        'start'
      );

    // 切换当前和下一张图片
    if (currentIndex >= $items.length - 1) {
      currentIndex = 0;
    } else {
      currentIndex++;
    }
  }, 8000);


  setTimeout(() => {
    gsap.set('.title-animate-in-slider', {
      animationFillMode: 'none',
      opacity: 1
    })
  }, 2000);
}

/** 设置全局的滑入动画 */
function setupGlobalAnimate() {

  gsap.registerPlugin(ScrollTrigger);
  // 选择需要添加动画的元素
  const elementsToAnimate = document.querySelectorAll('.animate-in-slider');

  elementsToAnimate.forEach((element) => {
    let canAnimate = true;

    const tl = gsap.timeline({ paused: true });
    tl.fromTo(
      element,
      {
        opacity: 0,
        y: 50 // 初始状态：透明度为 0，向下偏移 50px
      },
      {
        opacity: 1,
        y: 0, // 结束状态：透明度为 1，回到原始位置
        duration: 1,
        delay: 0.3, // 延迟 0.5 秒后开始动画
        ease: "power4.out", // 使用 Power4 缓动效果
      }
    );

    ScrollTrigger.create({
      trigger: element,
      start: 'top 90%', // 当元素顶部进入视口的 80% 位置时触发
      end: 'bottom bottom', // 当元素顶部进入视口的 80% 位置时触发
      onEnter: () => {
        if (!canAnimate) return;
        tl.play();
        canAnimate = false;
      },
      // markers: true

    });

  });
}

function setupFullScreenImageAnimate() {
  gsap.registerPlugin(ScrollTrigger);

  const res = [];
  document.querySelectorAll('.game-fullscreen-image-section').forEach((ele) => {
    const enableAnimate = ele.getAttribute('data-enable-animate');
    if (enableAnimate === 'false') {
      return;
    }

    const target = ele.querySelector('.full-screen-image-container');
    const overlay = ele.querySelector('.full-screen-image-overlay');

    // if (isWeChatBrowser()) {
    //   gsap.set(target , {
    //     "--change-ratio": '1'
    //   })
    //   return ;
    // }

    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: ele,
        start: 'top center',
        end: '+=100% bottom',
        scrub: 0.5,
        toggleActions: "play pause reverse pause",
        // markers: true, //debug
      },
    });

    // 全屏图片滚动动画
    tl.to(target, {
      "--change-ratio": '0.45',
      duration: 9,
      ease: 'none'
    }).to(target, {
      "--change-ratio": '1',
      duration: 1,
      ease: 'power4.out'
    })
      .fromTo(overlay, {
        opacity: 0,
      }, {
        opacity: 1,
        ease: 'power4.in'
      }, '<');

    // 固定配置
    ScrollTrigger.create({
      trigger: ele,
      start: 'top top',
      end: '+=150% bottom',
      pin: true,
      // markers: true, //debug
    });

    res.push(tl);

  })




  return res;
}

function setupGalleryAnimate(targetId) {
  gsap.registerPlugin(ScrollTrigger, ScrollToPlugin, Observer);

  //获取所有的gallery
  const galleryArr = document.querySelectorAll("game-product-gallery");

  let result;

  for (const galleryElement of galleryArr) {
    const triggerId = galleryElement.getAttribute("data-trigger");

    if (triggerId !== targetId) continue;
    // 进入节点
    const trigger = document.querySelector(`#${triggerId}`);
    const wrapper = trigger.querySelector('.game-product-gallery');

    // 盒子数量
    const boxItems = gsap.utils.toArray(`#${triggerId} .game-product-gallery .game-product-gallery-box`);
    const boxNumber = boxItems.length;

    const style = window.getComputedStyle(boxItems[0]);
    const mr = style.getPropertyValue("margin-right");
    const boxMargin = Number(mr.slice(0, -2));

    const boxWidth = boxItems[0].offsetWidth;
    const oneBoxOffestWidth = (boxMargin + boxWidth);


    let index = 0;


    const maxIndex = boxNumber - 1;
    const width = oneBoxOffestWidth * maxIndex;
    let isAnimate = false;

    //获取比例
    function calcIndexArr() {
      const arr = [];
      for (let i = 0; i < boxNumber; i++) {
        if (i == 0) {
          arr[i] = 0;
        } else {
          arr[i] = oneBoxOffestWidth * i
        }
      }
      return arr;
    }

    function getCurrentIndex() {
      // 获取当前的index
      let currentIndex = 0;
      const current = tl.scrollTrigger.scroll.v - tl.scrollTrigger.start;
      indexArr.forEach((r, index) => {
        if (current >= r) {
          currentIndex = index;
        }
      });
      return currentIndex;
    }

    const indexArr = calcIndexArr();

    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: trigger,
        // markers: true,
        pin: true,
        start: 'top top',
        end: `+=${width}px`,
        scrub: 1,
        toggleActions: 'play none reverse none',
        onUpdate: (self) => {
          // 获取当前的index
          const currentIndex = getCurrentIndex();
          index = currentIndex;

          // 更新class
          const navArr = trigger.querySelectorAll(".game-product-gallery-nav-item");
          navArr.forEach(nav => {
            let href = nav.getAttribute("href");
            if (Number(href.slice(href.lastIndexOf('-') + 1)) - 1 === currentIndex) {
              nav.classList.toggle("nav-active", true);
            } else {
              nav.classList.toggle("nav-active", false);
            }
          });


        }
      },
    });

    index = getCurrentIndex();
    tl.to(wrapper, {
      x: -1 * width,
      ease: 'none',
    });


    //设置nav点击事件
    const navArr = trigger.querySelectorAll(".game-product-gallery-nav-item");
    navArr.forEach(anchor => {
      anchor.addEventListener("click", function (e) {
        e.preventDefault();
        //找到需要跳转的元素
        let href = e.target.getAttribute("href"),
          targetElem = document.querySelector(href),
          y = targetElem;
        let index = Number(href.slice(href.lastIndexOf('-') + 1)) - 1;

        // 如果是我们容器内的元素，开始处理跳转具体的偏移量
        if (targetElem && wrapper.isSameNode(targetElem.parentElement)) {
          // 获取scrollTrigger的偏移高度
          let totalScroll = tl.scrollTrigger.end - tl.scrollTrigger.start;

          /**直接获取 */
          const offset = indexArr[index];

          // 计算偏移值
          y = Math.round(tl.scrollTrigger.start + offset);
        }

        // 跳转偏移值
        gsap.to(window, {
          scrollTo: {
            y: y,
            autoKill: false
          },
          duration: 0.2
        });

      });
    });

    if (isMobile) {
      const to = () => {
        const offset = indexArr[index];
        const y = Math.round(tl.scrollTrigger.start + offset);
        gsap.to(window, {
          scrollTo: {
            y: y,
            autoKill: false
          },
          duration: 0.2,
          onComplete: () => {
            isAnimate = false;
          },
          onInterrupt: () => {
            isAnimate = false;
          }
        });
      }

      const toNext = () => {
        if (index === maxIndex) {
        } else {
          index++;
        }
        isAnimate = true;
        to();
      }

      const toPrev = () => {
        if (index === 0) {
        } else {
          index--;
        }
        isAnimate = true;
        to();
      }

      Observer.create({
        lockAxis: true,
        target: wrapper, // can be any element (selector text is fine)
        type: "touch", // comma-delimited list of what to listen for
        onLeft: (self) => {
          if (isAnimate) return;
          toNext();
        },
        onRight: (self) => {
          if (isAnimate) return;
          toPrev();
        },
        tolerance: 10,
        // preventDefault: true
      });
    }

    result = tl;
  }

  return result;

}

function setupVideoAnimate() {
  const trigger = document.querySelector('.game-video-section');
  if (!trigger) {
    return;
  }
  const video = trigger.querySelector(".game-video");

  const overlay = trigger.querySelector(".game-video-overlay");

  const bannerSection = document.querySelector(".game-keyboard-banner-section");
  const bannerImage = document.querySelector(".game-keyboard-banner-image");


  if (isMobile) {
    bannerSection.classList.toggle("game-keyboard-banner-mobile-section", true)
    bannerImage.classList.toggle("game-keyboard-banner-mobile-image", true)
    trigger.classList.toggle("game-mobile-video-section", true);
    video.classList.toggle("game-mobile-video", true);
    overlay.style.display = 'none';
    video.controls = true;
    video.controlsList = 'nodownload noremoteplayback noplaybackrate';
    video.disablePictureInPicture = true;

    return;
  } else {
    bannerSection.classList.toggle("game-keyboard-banner-mobile-section", false)
    bannerImage.classList.toggle("game-keyboard-banner-mobile-image", false)
    trigger.classList.toggle("game-mobile-video-section", false);
    video.classList.toggle("game-mobile-video", false);
  }


  let first = true;
  const playButton = overlay.querySelector("#gameVideoPlayButton");
  const pauseButton = overlay.querySelector("#gameVideoPauseButton");
  const buttonWrapper = overlay.querySelector(".game-video-overlay-wrapper");

  ScrollTrigger.create({
    trigger: trigger,
    start: 'top center',
    end: '+=150% top',
    // markers: true,
    onToggle: (self) => {
      if (first && self.isActive) {
        video.muted = true;
        video.play().then((res) => {
          console.log(res);
        });
      }
      if (!self.isActive) {
        //如果离开了就暂停播放
        video.pause();
      }
    },
  });

  video.onclick = (e) => {
    first = !first;
    if (e.target.paused) {
      video.play();
    } else {
      video.pause();
    }
  };

  overlay.onclick = (e) => {
    first = !first;
    if (video.paused) {
      video.play();
    } else {
      video.pause();
    }
  }

  video.onplay = (e) => {
    onVideoPlay();
  }

  video.onpause = (e) => {
    onVideoPause();
  }

  if (video.paused) {
    onVideoPause();
  } else {
    onVideoPlay();
  }

  function onVideoPause() {
    buttonWrapper.style.display = 'none';
    playButton.style.display = 'block';
  }

  function onVideoPlay() {
    buttonWrapper.style.display = 'flex';
    playButton.style.display = 'none';
  }


  ScrollTrigger.create({
    trigger: trigger,
    start: 'top top',
    end: "+=150% bottom",
    // markers: true,
    pin: true
  });



  const imgTrigger = document.querySelector('.game-keyboard-banner-section');
  const tl = gsap.timeline({
    scrollTrigger: {
      trigger: imgTrigger,
      // pin: true,
      start: 'top bottom',
      end: "bottom bottom",
      scrub: true,
      // markers: true,
      toggleActions: 'play pause reverse pause',
    },
  });

  tl.to(trigger, {
    y: '100%'
  })

  return tl;

}

function setupVideo3DAnimate() {
  const trigger = document.querySelector('.game-video-3d-section');
  if (!trigger){
    return;
  }
  const container = trigger.querySelector(".game-video-3d-container");

  // if (isWeChatBrowser()) {
  //   gsap.set(container, {
  //     // to 状态
  //     x: 0,
  //     y: 0,
  //     z: 0,
  //     rotation: 0,
  //     rotationY: 0,
  //     rotationX: 0,
  //     scale: 1,
  //     clipPath: "inset(0%)",
  //     duration: 1,
  //     ease: "power2.out"
  //   })

  //   return ;
  // }


  const tl = gsap.timeline({
    scrollTrigger: {
      trigger: trigger,
      // pin: true,
      start: 'top bottom',
      end: "+=200% bottom",
      scrub: true,
      // markers: true,
      toggleActions: 'play pause reverse pause',
    },
  });

  tl.fromTo(container, {
    // from 状态
    x: 0,
    y: "-100%",
    z: "-600px",
    rotation: 20,
    rotationY: 15,
    rotationX: -15,
    scale: 1,
    clipPath: "inset(50%)"
  },
    {
      // to 状态
      x: 0,
      y: 0,
      z: 0,
      rotation: 0,
      rotationY: 0,
      rotationX: 0,
      scale: 1,
      clipPath: "inset(0%)",
      duration: 1,
      ease: "power2.out"
    });

  ScrollTrigger.create({
    trigger: trigger,
    start: 'top top',
    end: "+=200% bottom",
    // markers: true,
    pin: true
  });




  return tl;
}

function setupSlognAnimate() {


  function getScrollerContainer() {
    const container = document.querySelector(".game-slogn-marquee-container");
    return container;
  }

  function getScroller() {
    const scroller = document.querySelector("#game-slogn-marquee-scroller");
    return scroller;
  }

  /**
   * 初始化容器内容
   * @param {Element} container 
   * @param {Element} scroller 
   * @param {*} selector 
   */
  function setupItems(container, scroller, selector = ".game-slogn-marquee") {
    const itemElement = scroller.querySelector(selector);
    const itemWidth = itemElement.getBoundingClientRect().width;
    const containerWidth = container.getBoundingClientRect().width;
    const oneScreenNum = Math.ceil(containerWidth / itemWidth);
    const clonesNeeded = oneScreenNum * 2;

    //清空元素
    while (scroller.children.length > 1) {
      scroller.removeChild(scroller.lastChild);
    }

    // 添加克隆元素
    for (let i = 0; i < clonesNeeded; i++) {
      const clone = itemElement.cloneNode(true);
      scroller.appendChild(clone);
    }

    const moveTo = oneScreenNum * itemWidth;
    return moveTo;
  }

  /**
   *  marquee滚动动画
   * @param {Element} scroller
   * @param {number} moveTo 
   * @returns 
   */
  function createMarqueeAnimate(scroller, moveTo) {
    const infiniteTimeline = gsap.timeline({
      repeat: -1, // 无限循环
      defaults: {
        ease: "none" // 线性运动更自然
      }
    });

    infiniteTimeline.to(scroller, {
      x: -moveTo, // 移动距离为内容宽度
      duration: 25,     // 动画持续时间（秒）
    });
    // 第二阶段：瞬间复位（用户无感知）
    infiniteTimeline.set(scroller, {
      x: 0
    }, "+=0"); // 立即执行

    return infiniteTimeline;
  }

  // marquee滚动动画
  const scroller = getScroller();
  const container = getScrollerContainer();
  if (!container || !scroller) {
    return;
  }
  const moveTo = setupItems(container, scroller);
  return createMarqueeAnimate(scroller, moveTo);
}

function setupGloryGalleryAnimte() {

  const container = document.querySelector(".game-glory-gallery");
  if (!container) return;
  const scroller = container.querySelector(".game-glory-gallery-scroller");
  if(!scroller) return;
  const itemElement = scroller.querySelector(".game-glory-gallery-marquee");
  const itemWidth = itemElement.getBoundingClientRect().width;
  const containerWidth = container.getBoundingClientRect().width;
  const oneScreenNum = Math.ceil(containerWidth / itemWidth);
  const clonesNeeded = oneScreenNum * 3;

  //清空元素
  while (scroller.children.length > 0) {
    scroller.removeChild(scroller.lastChild);
  }

  // 添加克隆元素
  for (let i = 0; i < clonesNeeded; i++) {
    const clone = itemElement.cloneNode(true);
    scroller.appendChild(clone);
  }

  function getTranslateX(element) {
    const style = window.getComputedStyle(element);
    const transform = style.transform;
    const matrix = new DOMMatrix(transform);
    return matrix.m41; // 返回 X 轴的平移值
  }
  const initX = itemWidth;
  const moveTo = oneScreenNum * itemWidth + initX;


  let scrollX = 0;
  let baseX = 0;

  gsap.registerPlugin(Draggable);

  const infiniteTimeline = gsap.timeline({
    repeat: -1, // 无限循环
    defaults: {
      ease: "none" // 线性运动更自然
    }
  });
  infiniteTimeline.fromTo(scroller, {
    x: -initX
  }, {
    x: -moveTo,
    duration: 50,
  }).set(scroller, {
    x: 0
  }, "+=0");

  const proxy = document.createElement("div");

  Draggable.create(proxy, {
    type: "x",
    trigger: scroller,
    inertia: true,
    // bounds: {minX:-itemWidth, maxX: itemWidth},
    onPress() {
      infiniteTimeline.pause();
      baseX = this.x; // 记录初始位置
      scrollX = getTranslateX(scroller);
    },

    onDrag() {
      // 计算拖拽位移
      const offset = baseX - this.x;
      // 同步拖拽位置与时间轴进度  -
      const finalX = scrollX - offset;
      const progress = Math.abs(finalX) / (moveTo - initX);
      infiniteTimeline.progress(progress)
    },

    onThrowUpdate(self) {
      this.drag(); // 惯性滑动时保持同步
    },

    onRelease() {
      infiniteTimeline.play();
    }
  });


  return infiniteTimeline;
}

function setupScrollGalleryAnimate() {
  gsap.registerPlugin(ScrollTrigger);
  const trigger = document.querySelector('.game-scroll-gallery');
  if(!trigger){
    return;
  }
  const titleList = trigger.querySelector(".game-scroll-gallery-title-list");
  const titleItem = gsap.utils.toArray('.game-scroll-gallery-title-list .game-scroll-gallery-list-title-item');

  const listItem = gsap.utils.toArray('.game-scroll-gallery-list .game-scroll-gallery-list-item');


  // 获取titleItem 的高度
  const titleItemHeight = titleItem[0].getBoundingClientRect().height;

  // 计算titleList的高度
  const titleListHeight = titleItemHeight * titleItem.length;
  const titleItemHeightMiddle = (titleItemHeight / 4);
  const offset = titleListHeight - titleItemHeight + titleItemHeightMiddle;
  const indicator = document.querySelector('.game-scroll-gallery-indicator');
  let currentActiveIndex = -1;
  const calcIndicator = () => {
    // 获取指示器位置
    const indicatorRect = indicator.getBoundingClientRect();
    const indicatorY = indicatorRect.top + window.scrollY + indicatorRect.height / 2;

    // 计算当前激活项
    let activeIndex = -1;
    titleItem.forEach((item, index) => {
      const itemRect = item.getBoundingClientRect();
      const itemY = itemRect.top + window.scrollY;
      const itemCenterY = itemY + itemRect.height / 2;

      // 判断哪一项与指示器垂直对齐
      if (Math.abs(itemCenterY - indicatorY) < titleItemHeight / 2) {
        activeIndex = index;
      }
    });

    // 如果激活项变化
    if (activeIndex !== currentActiveIndex && activeIndex !== -1) {

      // 设置新激活项
      currentActiveIndex = activeIndex;
      activeItemEffect();
      // 切换背景图片
      listItem.forEach((i, index) => {
        i.classList.remove('active');
      });
      const current = listItem[currentActiveIndex];
      current.classList.add('active');

    }
  }

  const activeItemEffect = () => {
    const current = titleItem[currentActiveIndex];
    const prev2 = titleItem[currentActiveIndex - 2];
    const prev1 = titleItem[currentActiveIndex - 1];
    const next1 = titleItem[currentActiveIndex + 1];
    const next2 = titleItem[currentActiveIndex + 2];
    const classArr = ['active--2', 'active--1', 'active', 'active-1', 'active-2'];
    titleItem.forEach((i, index) => {
      i.classList.remove(...classArr);
    })
    if (prev2) {
      prev2.classList.add('active--2');
    }
    if (prev1) {
      prev1.classList.add('active--1');
    }
    if (next1) {
      next1.classList.add('active-1');
    }
    if (next2) {
      next2.classList.add('active-2');
    }
    current.classList.add('active');
  }

  const mainTl = gsap.timeline({
    scrollTrigger: {
      trigger: trigger,
      pin: true,
      start: 'top top',
      end: `+=400% bottom`,
      scrub: true,
      toggleActions: 'play pause reverse pause',
      onUpdate: () => {
        calcIndicator()
      }
    },
  });

  mainTl.fromTo(titleList, {
    y: -titleItemHeightMiddle,
  }, {
    y: -offset,
    ease: 'none',
  });
  calcIndicator();

  return [mainTl];
}

function initAnimations() {
  // 清理旧上下文
  ctx && ctx.revert();

  // 创建新上下文
  ctx = gsap.context(() => {
    const masterTimeLine = gsap.timeline();

    masterTimeLine
      .add(setupFullScreenImageAnimate())
      .add(setupGalleryAnimate("game-mouse-gallery-section"))
      // .add(setupVideoAnimate())
      .add(setupGalleryAnimate("game-keyboard-gallery-section"))
      .add(setupVideo3DAnimate());

    const tlArr = setupScrollGalleryAnimate();
    masterTimeLine.add(tlArr);

    //无限timeline
    // setupScreenAnimate();
    setupSlognAnimate();
    setupGloryGalleryAnimte();


    masterTimeLine.add(setupGlobalAnimate());

  });
}

function setAnnouncementBarHeight() {
  const ele = document.querySelector('.announcement-bar');
  const height = ele.getBoundingClientRect().height;
  const sectionEle = document.querySelector('body');
  sectionEle.style.setProperty("--announcement-bar-height", height + "px");
}

function setGameHomePageHeaderHeight() {
  const ele = document.querySelector('.header-wrapper');
  const height = ele.getBoundingClientRect().height;
  const sectionEle = document.getElementById('shopify-section-game-gallery-hero');
  sectionEle.style.setProperty("--game-header-height", height + "px");
}

// 判断是否是微信浏览器
function isWeChatBrowser() {
  const userAgent = window.navigator.userAgent.toLowerCase();
  return userAgent.match(/micromessenger/i) ? true : false;
}

function setViewportHeight() {
  const vh = window.outerHeight * 0.01;
  document.documentElement.style.setProperty('--wx-vh', `${vh}px`);
}

// 如果是微信浏览器，动态添加一个 CSS 类
if (isWeChatBrowser()) {
  document.body.classList.add('wechat-browser');
  setViewportHeight();
}

document.addEventListener("DOMContentLoaded", (event) => {
  // 计算css属性
  setAnnouncementBarHeight();
  setGameHomePageHeaderHeight();

  console.log("initLenis")
  initLenis();
  console.log("initLenis end")
  // gsap code here!
  // ScrollTrigger.config({autoRefreshEvents: "DOMContentLoaded,load,visibilitychange"});
  initAnimations()

  // 防抖函数
  function debounce(func, wait) {
    let timeout;
    return function () {
      const context = this;
      const args = arguments;
      clearTimeout(timeout);
      timeout = setTimeout(() => func.apply(context, args), wait);
    };
  }


  if (isMobile || isWeChatBrowser()) return;
  //监听窗口变化刷新
  window.addEventListener("resize", debounce(() => {
    // initAnimations();
    ScrollTrigger.refresh();
    setAnnouncementBarHeight();
    setGameHomePageHeaderHeight();

  }, 200));

});
